<label
  #tooltip="matTooltip"
  [matTooltip]="tooltipLabel"
  [matTooltipPosition]="toolTipPosition"
  [matTooltipHideDelay]="toolTipHideDelay">
  <mat-icon [color]="fontColor">{{ icon }}</mat-icon>
</label>
